import React, { useEffect, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { Button } from 'app/components/ui/button';
import { Monitor, Package, Wrench } from 'lucide-react';

// Product type constants - internal to products module
const PRODUCT_TYPES = {
  DIGITAL: 'digital',
  PHYSICAL: 'physical',
  SERVICES: 'services',
} as const;

export const ProductTypeSelector = () => {
  const { setValue, watch } = useFormContext();
  const productType = watch('product_type');
  const variantMode = watch('variant_mode');

  // Set default variant mode to 'single' if not set
  useEffect(() => {
    if (!variantMode) {
      setValue('variant_mode', 'single');
    }
  }, [setValue, variantMode]);

  // Memoize click handlers for better performance
  const handleDigitalClick = useCallback(() => {
    setValue('product_type', PRODUCT_TYPES.DIGITAL);
    setValue('variant_mode', 'single');
  }, [setValue]);

  const handlePhysicalClick = useCallback(() => {
    setValue('product_type', PRODUCT_TYPES.PHYSICAL);
    setValue('variant_mode', 'single');
  }, [setValue]);

  const handleServicesClick = useCallback(() => {
    setValue('product_type', PRODUCT_TYPES.SERVICES);
    setValue('variant_mode', 'single');
  }, [setValue]);

  return (
    <div className="space-y-3">
      <div className="flex space-x-1 p-1 bg-gray-100 dark:bg-gray-800 rounded-lg w-fit">
        <Button
          type="button"
          size="sm"
          className={`flex-1 h-10 ${
            productType === PRODUCT_TYPES.DIGITAL
              ? 'bg-primary dark:bg-gray-700 shadow-sm'
              : 'hover:bg-gray-200 dark:hover:bg-gray-700 bg-white text-gray-900 dark:text-gray-100 shadow-none'
          }`}
          onClick={handleDigitalClick}
        >
          <Monitor className="h-4 w-4 mr-2" />
          Digital Product
        </Button>
        <Button
          type="button"
          size="sm"
          className={`flex-1 h-10 ${
            productType === PRODUCT_TYPES.PHYSICAL
              ? 'bg-primary dark:bg-gray-700 shadow-sm'
              : 'hover:bg-gray-200 dark:hover:bg-gray-700 bg-white text-gray-900 dark:text-gray-100 shadow-none'
          }`}
          onClick={handlePhysicalClick}
        >
          <Package className="h-4 w-4 mr-2" />
          Physical Product
        </Button>
        <Button
          type="button"
          size="sm"
          className={`flex-1 h-10 ${
            productType === PRODUCT_TYPES.SERVICES
              ? 'bg-primary dark:bg-gray-700 shadow-sm'
              : 'hover:bg-gray-200 dark:hover:bg-gray-700 bg-white text-gray-900 dark:text-gray-100 shadow-none'
          }`}
          onClick={handleServicesClick}
        >
          <Wrench className="h-4 w-4 mr-2" />
          Services
        </Button>
      </div>
    </div>
  );
};
